import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { ISectionHeader, ICOAClassification } from '../../shared/models/classification';
import { ClassificationService } from '../../shared/services/classification.service';
import { ValidateNumeric, IsCodeNameExists } from '../../shared/common/customvalidator';
import { FrameworkService } from 'gadoe-framework';
@Component({
  selector: 'app-classificationgrideditform',
  templateUrl: './classificationgrideditform.component.html',
  styleUrls: ['./classificationgrideditform.component.css'],
  providers: [ClassificationService]
})
export class ClassificationgrideditformComponent implements OnInit {
  public active = false;
  model: ICOAClassification;
  fiscalYear: number;
  isPublishedchk: boolean;
  groupclassificationName: string;
  popupmessage: string = '';
  showPopup: boolean = false;
  buttonClick: string = '';
  ispublish: string;
  isAdmin: boolean;
  chcekGroupheadID: boolean;
  @Input() public isNew = false;
  /*  @Input() public lineitems : ICOAClassification[]=[]; */
  @Input() public groupHeaderId: number;
  @Input() public fiscalYearConfigId: number;
  @Input() set buttonClickValue(value: string) {
    this.buttonClick = value;
  }
  get buttonClickValue(): string {
    return this.buttonClick;
  }
  @Input() set isAdminVal(value: boolean) {
    this.isAdmin = value;
  }
  get isAdminVal(): boolean {
    return this.isAdmin;
  }
  @Input() set showPopupValue(value: boolean) {
    this.showPopup = value;
  }
  get showPopupValue(): boolean {
    return this.showPopup;
  }
  @Input() set groupclassificationNameValue(value: string) {
    this.groupclassificationName = value;
  }
  get groupclassificationNameValue(): string {
    return this.groupclassificationName;
  }

  @Input() set popupmessageValue(value: string) {
    this.popupmessage = value;
  }
  get popupmessageValue(): string {
     return this.popupmessage;
  }
  @Input() set fiscalYearValue(value: number) {
    this.fiscalYear = value;
  }
  get fiscalYearValue(): number {
    return this.fiscalYear;
  }
  sections: ISectionHeader[] = [];
  @Input() public set lineitems(product: ICOAClassification[]) {
      if (product !== undefined) {
      this.editForm.controls.code.setValidators(
        [Validators.required, IsCodeNameExists(this.groupHeaderId, this.fiscalYearConfigId, product)]);
    }
  }
  @Input() public set modelData(product: ICOAClassification) {
    this.modelInit();
    //  this.editForm.reset(product)
    if (product !== undefined) {
      this.getSection(product.groupHeaderID);
      if (product !== undefined && product.sectionLineItemColumnID !== -1) {
        this.model.sectionHeaderID = product.sectionHeaderID;
        this.editForm.reset({
          section: { value: product.sectionHeaderID, disabled: true },
          code: { value: product.code, disabled: true },
          name: { value: product.name, disabled: this.showPopup },
          description: { value: product.description, disabled: this.showPopup },
          isPublished: { value: product.isPublished, disabled: product.isPublished ? true : this.showPopup },
          lineItemID: product.lineItemID,
          sectionLineItemColumnID: product.sectionLineItemColumnID,
          sectionHeaderID: product.sectionHeaderID,
          groupHeaderID: product.groupHeaderID
        });
        this.isPublishedchk = product.isPublished;

      }
      if (product !== undefined && product.sectionLineItemColumnID === -1) {
        this.editForm.reset({
          section: { value: product.sectionHeaderID, disabled: false },
          code: { value: product.code, disabled: false },
          name: { value: product.name, disabled: false },
          description: { value: product.description, disabled: false },
          lineItemID: { value: product.lineItemID },
          sectionLineItemColumnID: { value: product.sectionLineItemColumnID },
          sectionHeaderID: { value: product.sectionHeaderID },
          isPublished: { value: product.isPublished, disabled: false },
          groupHeaderID: { value: product.groupHeaderID }
        });
      }
 if (product.groupHeaderID === 9) {
  this.chcekGroupheadID = false;
 } else {
  this.chcekGroupheadID = true;

 }
      this.active = product !== undefined;
    }
  }
  @Output() cancel: EventEmitter<any> = new EventEmitter();
  @Output() save: EventEmitter<ICOAClassification> = new EventEmitter();
  @Output() endOrdelete: EventEmitter<string> = new EventEmitter();

  public editForm: FormGroup = new FormGroup({
    'section': new FormControl('', Validators.required),
    'code': new FormControl('', [Validators.required, IsCodeNameExists(this.groupHeaderId, this.fiscalYearConfigId, this.lineitems)]),
    'name': new FormControl('', Validators.required),
    'description': new FormControl('', Validators.required),
    'lineItemID': new FormControl(''),
    'isPublished': new FormControl(false),
    'sectionLineItemColumnID': new FormControl('')
  });
  constructor(private frmbuilder: FormBuilder, private frameworkService: FrameworkService,
    private dataService: ClassificationService
  ) {
  }

  ngOnInit() {
    this.modelInit();
    this.classificationFormInit();
  }
  modelInit() {
    this.model = {
      sectionLineItemColumnID: -1,
      groupHeaderID: -1,
      groupHeaderName: '',
      sectionHeaderID: -1,
      lineItemID: -1,
      name: '',
      code: '',
      description: '',
      isActive: false,
      isPublished: false,
      isPublishedStatus: '',
      groupHeaderIntroduction: '',
      sectionHeaderName: '',
      sName: '',
      createdBy: 0,
      startYear: 0,
      activeStatus: ''
    };
    this.chcekGroupheadID = false;
  }
  classificationFormInit() {
    this.editForm = this.frmbuilder.group({
      section: [this.model.sectionHeaderID, [Validators.required]],
      code: [this.model.code, [Validators.required, IsCodeNameExists(this.groupHeaderId, this.fiscalYearConfigId, this.lineitems)]],
      name: [this.model.name, Validators.required],
      description: [this.model.description, Validators.required],
      lineItemID: [this.model.lineItemID],
      sectionLineItemColumnID: [this.model.sectionLineItemColumnID],
      sectionHeaderID: [this.model.sectionHeaderID],
      isPublished: [this.model.isPublished],
      groupHeaderID: [this.model.groupHeaderID]
    });
  }

  getSection(grp: number) {
    this.dataService.getSections(grp)
      .subscribe((response: ISectionHeader[]) => {
        this.sections = response;
        if (this.isNew) {
          this.model.sectionHeaderID = this.sections[0].sectionHeaderID;
          this.isPublishedchk = false;
        } else {

        }
      },
        (err: any) => this.frameworkService.logError(err),
        () => this.frameworkService.logInfo('EditForm getSections() retrieved getSections'));
  }

  public onSave(e): void {
    e.preventDefault();
    if (this.isNew) {
      this.model.sectionLineItemColumnID = this.editForm.value.sectionLineItemColumnID.value;
      this.model.lineItemID = this.editForm.value.lineItemID.value;
      this.model.groupHeaderID = this.editForm.value.groupHeaderID.value;
    } else {
      this.model.sectionLineItemColumnID = this.editForm.value.sectionLineItemColumnID;
      this.model.lineItemID = this.editForm.value.lineItemID;
      this.model.groupHeaderID = this.editForm.value.groupHeaderID;
    }

    this.model.code = this.editForm.controls['code'].value;
    this.model.name = this.editForm.value.name;
    this.model.description = this.editForm.value.description;
    if (this.editForm.controls['isPublished'].value.value === undefined) {
      this.model.isPublished = this.editForm.controls['isPublished'].value;
    } else {
      this.model.isPublished = this.editForm.controls['isPublished'].value.value;
    }
    this.save.emit(this.model);
    this.active = false;
   
  }
  public onEndYear(e): void {
    e.preventDefault();
    this.endOrdelete.emit('yes');
    this.active = false;
    this.frameworkService.showSuccessMessage( 'End Year successfully');

  }

  public onDelete(e): void {
    e.preventDefault();
    this.endOrdelete.emit('yes');
    this.active = false;
    this.frameworkService.showSuccessMessage( 'Deleted successfully');

  }
  public onCancel(e): void {
    e.preventDefault();
    this.closeForm();
  }

  private closeForm(): void {
    this.active = false;
    this.cancel.emit();

  }
  onlyNumeric(e) {
    ValidateNumeric(e);
  }
}
